import { isSidecarDomain } from './isSidecarDomain'

export const getEnv = (host?: string): string => {
  if (process.env.APP_ENV) {
    const env = process.env.APP_ENV
    return env === 'production' ? 'prod' : env
  }

  if (typeof host === 'string' && isSidecarDomain(host)) {
    if (host.includes('-')) {
      return host.split('-')[0]
    } else {
      return 'prod'
    }
  }

  return 'dev'
}
